import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import LoadingButton from '@mui/lab/LoadingButton';
import styles from './EditCycle.module.scss';
import Form from '../../../../Common/Form/Form';
import APIClient from '../../../../../../util/APIClient';
import FormAlert from '../../../../Common/FormAlert/FormAlert';
import FormTextField from '../../../../Common/FormTextField/FormTextField';
import Loading from '../../../../Common/Loading/Loading';
import { getErrorComponentFromHttpError } from '../../../../Common/Error/Error';
import useApiData from '../../../../../../hooks/useApiData';

export default function EditCycle() {
  const { cycleId } = useParams();
  const navigate = useNavigate();
  const [formAlert, setFormAlert] = React.useState(null);
  const [isSubmitting, setIsSubmitting] = React.useState(false);
  const [hasSubmitted, setHasSubmitted] = React.useState(false);

  const { data, isLoading, error } = useApiData({
    path: `/administrator/cycles/${cycleId}`,
  });

  async function onSubmit(data) {
    setIsSubmitting(true);
    const cycle = {
      label: data.label,
    };

    try {
      const response = await APIClient.put(
        `/administrator/cycles/${cycleId}`,
        cycle,
      );
      setHasSubmitted(true);
      setFormAlert({
        severity: 'success',
        title: 'Cycle updated successfully!',
        message:
          'Your cycle has been updated successfully. You will be redirected shortly.',
      });
      setTimeout(() => {
        navigate(`/administrator/organisation/cycles/${cycleId}`);
      }, 3000);
    } catch {
      setFormAlert({
        severity: 'error',
        title: 'Could not update cycle!',
        message:
          'Something went wrong during cycle update. Please contact the administrator for further support.',
      });
    } finally {
      setIsSubmitting(false);
    }
  }

  if (isLoading) {
    return <Loading message="Fetching cycle..." />;
  }

  if (error || data === null) {
    return getErrorComponentFromHttpError(error);
  }

  return (
    <div className={styles.editCycle}>
      <h1>Edit cycle</h1>
      <p className={styles.description}>Edit a cycle using the form below.</p>
      <Form onSubmit={(data) => onSubmit(data)}>
        <FormTextField
          name="label"
          label="Label"
          helperText="Label for this cycle."
          defaultValue={data.label}
        />
        <div className={styles.formControls}>
          <LoadingButton
            variant="contained"
            type="submit"
            loading={isSubmitting}
            disabled={hasSubmitted}
            fullWidth
          >
            <span>Save Changes</span>
          </LoadingButton>
        </div>
        {formAlert && <FormAlert alert={formAlert} />}
      </Form>
    </div>
  );
}
